$('input[type=radio][name=community_tab]').on('change', function () {
    let where_bug_happened = document.getElementById('where_bug_happened')
    let level_of_frustration = document.getElementById('edit-level-of-frustration--wrapper')
    if ($(this).val() === 'Bug') {
        where_bug_happened.style.removeProperty('display')
        level_of_frustration.style.removeProperty('display')
    } else {
        where_bug_happened.style.display = 'none'
        level_of_frustration.style.display = 'none'
    }
});
